import { useTranslation } from 'react-i18next';
import ButtonSpecial from '../ButtonSpecial';
import { ContActionDemo, ContBtnActionDemo, TextActionDemo, TitleActionDemo } from './ActionDemo.styles';

export const ActionDemo = () => {
  const { t } = useTranslation();
  return (
    <ContActionDemo>
      <div className={'container-fit'}>
        <TitleActionDemo>
        {t('¡Transformamos tu financiera desde el Core!')}
        </TitleActionDemo>
        <TextActionDemo>
        {t('El Core Bancario que te ayuda a automatizar procesos y gestionar productos financieros digitales.')}
        </TextActionDemo>
        <ContBtnActionDemo>
          <ButtonSpecial
            text={'Prueba la versión Demo'}
            type={'/'}
            linkTo={'/contacto'}
            location={'/demo'}
            theme={'tertiary'}
            target={'_self'}
          />
        </ContBtnActionDemo>
      </div>
    </ContActionDemo>
  )
}
